<template>
  <div class="map_container">
    <!-- <div style="height: 100%; width: 100%; position: absolute; z-index: 9999999"
         v-if="isLoading">
      <a-spin size="large"
              style="top: 50%; right: 50%; position: absolute" />
    </div> -->
    <div class="changeBtn" v-if="!showLengend">
      <a-button type="primary" @click="changeShow">显示图例</a-button>
    </div>
    <div class="lengend" v-show="showLengend">
      <div class="lengend_title">
        <span class="legend_title--prefix"></span>
        <span class="legend_title--content">图例</span>
        <img src="@/assets/myImg/1/icon-close.png" class="legend_title--sufix" @click="showLengend = !showLengend" />
      </div>
      <div class="layers">
        <div class="layer" v-for="(item, index) in filterLayerList" :key="item.id" @click="clickLabel(item, index)">
          <span class="layer-prefix">
            <template v-if="item.style">
              <template v-if="item.style.styleType == 1">
                <img :src="item.style.styleValue" class="prefix_icon" />
              </template>
              <template v-if="item.style.styleType == 2">
                <div style="width: 20px; height: 20px; margin-left: 12px; margin-right: 12px">
                  <svg style="width: 100%; height: 100%">
                    <g fill="none" :stroke="item.style.styleValue | useStyle1">
                      <path :stroke-width="item.style.styleValue | useStyle2" d="M0 15 l65 0"
                        :stroke-dasharray="item.style.styleValue | useStyle3" />
                    </g>
                  </svg>
                  <svg style="width: 100%; height: 50%" viewBox="-3 2 22 3">
                    <g fill="none" :stroke="item.style.styleValue | useStyle1">
                      <path d="M3,5 l1,-3 l1,3" :stroke-linejoin="item.style.styleValue | useStyle4" />
                    </g>
                  </svg>
                </div>
              </template>
              <template v-if="item.style.styleType == 3">
                <div style="height: 20px; width: 20px; margin-left: 12px; margin-right: 12px"
                  :style="item.style.styleValue | useStyle"></div>
              </template>
            </template>
          </span>
          <span class="layer-content">
            <a-tooltip style="font-size: 10px">
              <template slot="title">{{ item.layerName }}</template>
              {{ item.layerName.substring(0, 8) }}
            </a-tooltip>
          </span>
          <img class="layer-sufix" src="@/assets/myImg/1/icon-choose.png" v-show="item.show" />
        </div>
      </div>
    </div>
    <a-modal title="街景" :visible="showStreetView" width="80%" destroyOnClose @ok="closeStreetView"
      @cancel="closeStreetView" style="position: absolute; left: 18rem; z-index: 999; top: 3rem">
      <BaiDuMap ref="baidumap" :chooseCoordinates="chooseCoordinates"></BaiDuMap>
    </a-modal>
    <div :id="domId" class="map" @drop="onDrop" @dragover="onDrop">
      <div id="popup" class="ol-popup" :style="{ opacity: showOw ? 1 : 0 }" draggable="true" @dragstart="onDrag"
        @dragend="onDragEnd">
        <div class="popup_title">
          <span class="popup_title--prefix"></span>
          <span class="popup_title--content">详情</span>
          <img src="@/assets/myImg/1/icon-close.png" class="popup_title--sufix" id="popup-closer"
            @click="closeOverLay" />
        </div>
        <div id="popup-content">
          <div id="popup-content-page">
            <ul style="padding: 0px 10px">
              <li v-for="(item, index) in popupObject" :key="index"
                style="padding-top: 8px; font-family: MicrosoftYaHei; font-size: 13px; color: #ffffff; font-weight: 400">
                <span style="font-family: MicrosoftYaHei; font-size: 13px; color: #ffffff; font-weight: 400">{{
                  item[0]
                }}</span>:
                <span v-if="item[0] == '表数量'" style="cursor: pointer; color: rgb(47 218 88)"
                  @click="checkWaterNum(popupObject)">{{ item[1] }}</span>
                <span v-else>{{ item[1] }}</span>
              </li>
            </ul>
          </div>
          <!-- <a-spin style="margin-left:110px;margin-top:40px" v-else></a-spin> -->
        </div>
      </div>
    </div>
    <water-number-modal ref="WaterNumberModal"></water-number-modal>
  </div>
</template>
<script>
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import * as olProj from 'ol/proj'
import { saveAs } from 'file-saver'
import ImageWMS from 'ol/source/ImageWMS'
import ImageLayer from 'ol/layer/Image'
import { getLegendDetailByCode, getGeophysicalPoint } from '@/api/manage'
import { getUUID } from '@/utils/util'
import Overlay from 'ol/Overlay'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import Polygon from 'ol/geom/Polygon'
import Style from 'ol/style/Style'
import Circle from 'ol/style/Circle'
import Icon from 'ol/style/Icon'
import ScaleLine from 'ol/control/ScaleLine'
import { unByKey } from 'ol/Observable'
import iconQuery from '@/assets/myImg/1/ns-icon-query.svg'
import iconQueryLight from '@/assets/myImg/1/ns-icon-query-light.svg'
import BigMapDrawer from './bigMapDrawer'
import { gcj02tobd09, wgs84togcj02 } from './zuobiaozhuanhuan'
import mapDiaphaneity from './mapDiaphaneity'
import BaiDuMap from './BaiDuMap.vue'
import * as turf from '@turf/turf'
import dragBox from './dragBox'
import printJs from 'print-js'
import { defaults } from 'ol/interaction'
import WaterNumberModal from './RemoteNumberModal'
let map = null
let lightFeature = null
let x = 0
let y = 0
// let map = null
export default {
  name: 'BigMap',
  components: {
    WaterNumberModal,
    iconQuery,
    dragBox,
    iconQueryLight,
    BigMapDrawer,
    BaiDuMap,
    mapDiaphaneity
  },
  data () {
    return {
      showMapAlpha: false,
      showOw: true,
      visible: false,
      tubeVisible: false,
      domId: getUUID(),
      showMapControl: false,
      openyxcxTable: false,
      openQueryTable: false,
      opensscxTable: false,
      opendlcsTable: false,
      diameter: '',
      material: '',
      isLoading: false,
      sscxInputData: null,
      radioGroupValue: 1,
      cqlString: '',
      layerList: [],
      lightFeature: null,
      showLengend: true,
      popupObject: [],
      streetViewButton: false,
      showStreetView: false,
      chooseCoordinates: [],
      clickTypeList: [],
      visibleTubeAnalysis: false, // 爆管分析
      layer_numberId: ''
    }
  },
  filters: {
    useStyle: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `background:${arrs[0]};border:${arrs[1]} ${arrs[3]}px solid; opacity:${arrs[2]}; width:20px`
    },
    useStyle1: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[1]}`
    },
    useStyle2: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[0]}`
    },
    useStyle3: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[2]}`
    },
    useStyle4: (value) => {
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        arrs.push(arr[i].split(':')[1])
      }
      return `${arrs[3]}`
    }
  },
  mounted () {
    this.initMap()
  },
  computed: {
    filterLayerList: function () {
      return this.layerList.filter(function (item) {
        return item.showLegend
      })
    }
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    showLegend: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkWaterNum (params) {
      const arr = params.find((item) => {
        return item[0] == '分类编码'
      })
      console.log(arr[1])
      this.$refs.WaterNumberModal.edit(arr[1])
    },
    changeShow () {
      this.showLengend = true
    },
    onDragEnd (e) {
      e.dataTransfer.dropEffect = 'copy'
      const tx = e.clientX - x + 'px'
      const ty = e.clientY - y + 'px'
      // e.srcElement.offsetParent.style.transform=e.srcElement.offsetParent.style.transform+ ` translate(${tx}, ${ty})`;
      document.getElementById('popup').style.transform =
        document.getElementById('popup').style.transform + ` translate(${tx}, ${ty})`
      x = 0
      y = 0
      e.preventDefault()
    },
    onDrop (e) {
      e.preventDefault()
    },
    onDrag (e) {
      x = e.clientX
      y = e.clientY
      e.dataTransfer.effectAllowed = 'copyMove'
    },
    // 工具框选方法
    kuangXuan (arr) {
      console.log(arr)
      this.$refs.FrameDataModal.edit(arr)
      //  this.showMapControl=false
    },
    // 查看用户数量详细信息
    checkUserNum (params) {
      this.$refs.userNumberModal.edit(params)
    },
    // 查看爆管详情
    checkDetails (id) {
      this.$refs.tubeAnalysisModal.edit(id)
    },
    setResolutions (resolutions) {
      map.resolutions = resolutions
    },
    addLayer (layer) {
      map.addLayer(layer)
    },
    getBigMap () {
      return map
    },
    setMaxZoom (zoom) {
      map.getView().setMaxZoom(zoom)
    },
    tileUrlFunction (coord, params1, params2) {
      return this.getVETileUrl(coord[0], coord[1], coord[2])
    },
    getVETileUrl (z, x, y) {
      for (var a = '', c = x, d = y, e = 0; e < z; e++) {
        a = ((c & 1) + 2 * (d & 1)).toString() + a
        c >>= 1
        d >>= 1
      }
      return 'http://dynamic.t0.tiles.ditu.live.com/comp/ch/' + a + '?it=G,VE,BX,L,LA&mkt=zh-cn,syr&n=z&og=111&ur=CN'
    },
    initMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      map = new Map({
        view: new View({
          center: [113.69374851887473, 25.563884415045945], // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 12.15, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        interactions: defaults({
          doubleClickZoom: false // 取消双击放大功能交互
        }),
        target: this.domId // 地图容器id
      })
      const scaleLineControl = new ScaleLine({
        // 设置度量单位为米
        units: 'metric',
        target: 'scalebar',
        className: 'ol-scale-line'
      })
      map.addControl(scaleLineControl)
      const roadLayer = new TileLayer({
        name: '底图',
        title: '必应地图',
        source: new XYZ({
          projection: gcjMecator,
          crossOrigin: 'anonymous',
          tileUrlFunction: this.tileUrlFunction
          // url: 'https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}' //深色地图
          // url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        })
      })
      map.addLayer(roadLayer)
      this.location()
      this.getLayers()
    },
    showDrawer () {
      this.tubeVisible = false
      this.visible = !this.visible
      this.$refs.Drawer.show()
    },
    showTubeDrawer () {
      this.visible = false
      this.tubeVisible = !this.tubeVisible
      if (this.tubeVisible) {
        this.removeLayerByName('停水分析')
      }
    },
    onClose () {
      this.visible = false
    },
    openStreetView () {
      // this.chooseCoordinates
      this.showStreetView = true
    },
    closeStreetView () {
      this.showStreetView = false
    },
    clickLabel (item, index) {
      var thisName = item.id
      console.log(item.id)
      const allLayers = map.getLayers()
      allLayers.array_.forEach((items) => {
        if (thisName === items.values_.name) {
          //  console.log(items.values_.visible)
          //  items.values_.visible=!items.values_.visible
          items.setVisible(!items.values_.visible)
          // var divs = document.getElementsByClassName('layer-content')[index]
          const filterIndex = this.layerList.findIndex((layer) => {
            return layer.id == thisName
          })
          console.log(items.values_.visible)
          this.$set(this.layerList, filterIndex, { ...item, show: items.values_.visible })

          //  if (!items.values_.visible) {

          //  } else {
          //   divs.style.color = 'rgba(0,255,255,0.5)'
          //  }
        }
      })
    },
    getLayers () {
      getLegendDetailByCode(this.code)
        .then(({ data }) => {
          const { layerList } = data
          layerList.forEach(layer => { if (layer.showFilterCondition) { layer.showFilterCondition = layer.showFilterCondition.replace(/is_deleted\s*=\s*0/g, 'is_deleted = false') } })
          if (layerList && layerList.length > 0) {
            this.layerList = layerList.map((v) => ({ ...v, show: !!v.defaultLoad }))
            console.log(this.layerList)
            layerList.map((layer) => {
              if (layer.style.styleType === 1) {
                console.log(layer.showLegend)
                // if (!layer.showLegend) {
                this.wmsLayers(layer, layer.showFilterCondition, layer.defaultLoad)
                // } else {
                //   this.wmsLayers(layer, layer.showFilterCondition, false)
                // }
              } else {
                this.wmsLayers(layer, layer.showFilterCondition, true)
              }
            })
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    removeLayerByName (name) {
      const allLayers = map.getLayers()
      allLayers.array_.forEach((item) => {
        if (item.values_.name === name) {
          map.removeLayer(item)
        }
      })
    },
    queryData (type) {
      this.cqlString = ''
      if (type === '设施查询') {
        if (this.radioGroupValue === 1) {
          // this.cqlString = '&CQL_FILTER=%20%22geophysical_point_number%22LIKE%27' + this.sscxInputData + '%27'
          this.cqlString = '"geophysical_point_number"=\'' + this.sscxInputData + "'"
        }
        if (this.radioGroupValue === 2) {
          // this.cqlString = '&CQL_FILTER=%20%22feature_point%22LIKE%27' + this.sscxInputData + '%27'
          this.cqlString = '"feature_point"=\'' + this.sscxInputData + "'"
        }
        if (this.sscxInputData === '水表' || this.sscxInputData === '阀门井') {
          this.wmsLayers('smart_water:pipe_network', this.cqlString)
        } else {
          this.wmsLayers('smart_water:pipe_network', this.cqlString)
        }
      }
      if (type === '条件查询') {
        // diameter  material
        if (this.diameter.length > 0 && this.material.length > 0) {
          // this.cqlString = '&CQL_FILTER=%20%22pipeline_material%22LIKE%27' + this.material + '%27and%20%22pipe_diameter_size%22=' + Number(this.diameter)
          this.cqlString =
            '"pipeline_material"=\'' + this.material + '\'and"pipe_diameter_size"=' + Number(this.diameter)
        } else if (this.material.length > 0) {
          // this.cqlString = '&CQL_FILTER=%20%22pipeline_material%22LIKE%27' + this.material + '%27'
          this.cqlString = '"pipeline_material"=\'' + this.material + "'"
        } else if (this.diameter.length > 0) {
          this.cqlString = '"pipe_diameter_size"=' + Number(this.diameter)
          // this.cqlString = '&CQL_FILTER=%22pipe_diameter_size%22=' + Number(this.diameter)
        }
        this.wmsLayers('smart_water:pipe_network', this.cqlString)
      }
    },
    opensscxTables () {
      this.opensscxTable = !this.opensscxTable
      if (this.opensscxTable) {
        this.opendlcsTable = false
        this.openyxcxTable = false
        this.openQueryTable = false
      }
    },
    opendlcsTables () {
      this.opendlcsTable = !this.opendlcsTable
      if (this.opendlcsTable) {
        this.opensscxTable = false
        this.openyxcxTable = false
        this.openQueryTable = false
      }
    },
    openyxcxTables () {
      this.openyxcxTable = !this.openyxcxTable
      if (this.openyxcxTable) {
        this.openQueryTable = false
        this.opensscxTable = false
        this.opendlcsTable = false
      }
    },
    openQuery () {
      this.openQueryTable = !this.openQueryTable
      if (this.openQueryTable) {
        this.openyxcxTable = false
        this.opensscxTable = false
        this.opendlcsTable = false
      }
    },
    simplePoint (data, name) {
      console.log('RemoteWaterMap=====simplePoint=====')
      const vectorSource = new VectorSource()
      data.forEach((item) => {
        const point = new Point(item)
        map.getView().setCenter(item)
        const feature = new Feature(point)
        vectorSource.addFeature(feature)
      })
      console.log('vectorSource', vectorSource)
      var vectorLayer = new VectorLayer({ source: vectorSource, name: name, zIndex: 999999 })
      // 设置feature的样式
      vectorLayer.setStyle(
        new Style({
          image: new Icon({
            crossOrigin: 'anonymous',
            src: require('@/assets/myImg/1/icon-阀门.png'),
            scale: 0.5
          })
        })
      )
      map.getView().setZoom(16)
      map.addLayer(vectorLayer)
    },
    wmsLayers (layer, cql = '', isVisible = true) {
      this.removeLayerByName(layer.id)
      this.closeOverLay()
      console.log('进来', layer)
      lightFeature.getGeometry().setCoordinates([0, 0])
      const params = { LAYERS: layer.dataSource, FORMAT: 'image/png' }
      if (cql) params.CQL_FILTER = cql
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params,
        serverType: 'geoserver',
        url: `/api/geoserver/${layer.workspace}/wms`
      })
      const wmsLayer = new ImageLayer({
        name: layer.id,
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: 9999
      })
      wmsLayer.setVisible(isVisible)
      map.addLayer(wmsLayer)
      var that = this
      if (layer.dataSource === 'smart_water:pipe_line_layer') {
        wmsSource.on('imageloadstart', function (event) {
          console.log('渲染中', layer)
          that.isLoading = true
          // ----打开Loading
        })
        // postrender
        wmsSource.on('imageloadend', function (event) {
          console.log('渲染完成', layer)
          that.isLoading = false
          // // ----关闭Loading
        })
      }
      if (
        layer.dataSource !== 'smart_water:water_supply_range' &&
        layer.dataSource !== 'smart_water:water_factory_area'
      ) {
        this.clickWMS(wmsSource, layer, wmsLayer)
      }
    },
    queryWmsLayers (workspace, layerName, cql) {
      this.removeLayerByName('condition_query_wms_layer')
      this.closeOverLay()
      lightFeature.getGeometry().setCoordinates([0, 0])
      const params = { LAYERS: layerName, FORMAT: 'image/png' }
      if (cql) params.CQL_FILTER = cql
      const wmsSource = new ImageWMS({
        crossOrigin: 'anonymous',
        params,
        serverType: 'geoserver',
        url: `/api/geoserver/${workspace}/wms`
      })
      const wmsLayer = new ImageLayer({
        name: 'condition_query_wms_layer',
        crossOrigin: 'anonymous',
        projection: 'EPSG:4490',
        source: wmsSource,
        zIndex: 9999
      })
      map.addLayer(wmsLayer)
      // this.clickWMS(wmsSource, layer)
    },
    // WMS点击事件
    clickWMS (wmsSource, layer, wmsLayer) {
      // if (Object.keys(this.clickTypeList).indexOf(layer.id) === -1){
      unByKey(this.clickTypeList[layer.id])
      console.log('this.clickTypeList', this.clickTypeList)
      var that = this
      this.clickTypeList[layer.id] = map.on(
        'click',
        function (e) {
          const url = wmsSource.getFeatureInfoUrl(e.coordinate, map.getView().getResolution(), 'EPSG:4326', {
            INFO_FORMAT: 'application/json'
          })
          // 判断是否有要素，一般wms返回的是false没有要素，所以wms的功能代码在else里
          if (map.hasFeatureAtPixel(e.coordinate)) {
            if (url) {
              fetch(url)
                .then((response) => {
                  return response.json()
                })
                .then((data) => { })
            }
          } else {
            if (url) {
              fetch(url)
                .then((response) => {
                  return response.json()
                })
                .then((data) => {
                  if (data.features.length != 0) {
                    if (wmsLayer.values_.visible) {
                      const layer_id = data.features[0].id.split('.')[0]
                      this.layer_numberId = data.features[0].id.split('.')[1]
                      that.addOverLay(e.coordinate, layer_id, data.features[0].properties)
                      if (layer_id === 'pipe_network' || layer_id === 'pipe_line_layer') {
                        that.streetViewButton = true
                        // that.chooseCoordinates = wgs84togcj02(e.coordinate[0], e.coordinate[1]);
                        const wgs84togcj02Data = wgs84togcj02(e.coordinate[0], e.coordinate[1])
                        that.chooseCoordinates = gcj02tobd09(wgs84togcj02Data[0], wgs84togcj02Data[1])
                        lightFeature.getGeometry().setCoordinates(data.features[0].geometry.coordinates)
                      } else if (layer_id === 'zone_metering') {
                        var leval = data.features[0].properties.level
                        var downCode = data.features[0].id
                        // alert(leval)
                        if (leval <= 2) {
                          leval += 1
                          // level = 1
                          var cqls = 'is_deleted = false and pid = ' + String(downCode)
                          console.log(cqls)
                          that.wmsLayers(layer, cqls)
                        }
                        // that.wmsLayers()
                      }
                    }
                  }
                })
            }
          }
        }.bind(this)
      )
      // }
    },
    // 百度坐标转高德（传入经度、纬度）
    bd_decrypt (bd_lng, bd_lat) {
      var X_PI = (Math.PI * 3000.0) / 180.0
      var x = bd_lng - 0.0065
      var y = bd_lat - 0.006
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI)
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
      var gg_lng = z * Math.cos(theta)
      var gg_lat = z * Math.sin(theta)
      return [gg_lng, gg_lat]
    },
    exportMap () {
      map.once('rendercomplete', function () {
        // let that = this
        const mapCanvas = document.createElement('canvas')
        const size = map.getSize()
        mapCanvas.width = size[0]
        mapCanvas.height = size[1]
        const mapContext = mapCanvas.getContext('2d')
        Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function (canvas) {
          if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity
            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity)
            const transform = canvas.style.transform
            const matrix = transform
              .match(/^matrix\(([^\(]*)\)$/)[1]
              .split(',')
              .map(Number)
            CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix)
            mapContext.drawImage(canvas, 0, 0)
          }
        })
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(mapCanvas.msToBlob(), '导出图片.png')
        } else {
          mapCanvas.toBlob(function (blob) {
            saveAs(blob, '导出图片.png')
          })
        }
      })
      map.renderSync()
    },
    // 爆管
    tubeAnalysis () {
      this.removeLayerByName('停水分析')
      this.$nextTick(() => {
        this.visible = false
        this.tubeVisible = true
        this.$refs.tubeDrawer.check(this.layer_numberId)
      })
      this.popupObject.forEach((item) => {
        if (item[0] === '物探点号' || item[0] === '物探起点点号') {
          getGeophysicalPoint(item[1]).then((data) => {
            const xList = []
            const yList = []
            if (data.data.length > 1) {
              data.data.forEach((items) => {
                xList.push(Number(items[0]))
                yList.push(Number(items[1]))
              })
              const minX = Math.min(...xList)
              const maxX = Math.max(...xList)
              const minY = Math.min(...yList)
              const maxY = Math.max(...yList)
              var PolygonGeom = [
                [
                  [minX, maxY],
                  [maxX, maxY],
                  [maxX, minY],
                  [minX, minY],
                  [minX, maxY]
                ]
              ]
              this.simplePolygon(PolygonGeom, '停水分析')
            }
          })
        }
      })
    },
    // 面数据绘制
    simplePolygon (data, name) {
      // debugger
      const vectorSource = new VectorSource()
      const polygon = new Polygon(data)
      const feature = new Feature(polygon)
      vectorSource.addFeature(feature)
      console.log('vectorSource', vectorSource)
      var vectorLayer = new VectorLayer({ source: vectorSource, name: name, zIndex: 999999 })
      var polygonSize = feature.getGeometry()
      map.getView().fit(polygonSize)
      // 设置feature的样式
      vectorLayer.setStyle(
        new Style({
          fill: new Fill({
            // 矢量图层填充颜色，以及透明度
            color: 'rgba(0, 255, 255, 0.6)'
          })
        })
      )
      // map.getView().setZoom(16)
      map.addLayer(vectorLayer)
    },
    printpage () {
      printJs('popup-content-page', 'html')
    },
    printMap () {
      window.print()
    },
    // 级别加减
    changeZoom (type) {
      if (type) {
        map.getView().setZoom(map.getView().getZoom() + 1)
      } else {
        map.getView().setZoom(map.getView().getZoom() - 1)
      }
    },
    // 爆管分析跳转
    jumpFather (record) {
      console.log(record)
      map.getView().setCenter([record.coordinatePointX, record.coordinatePointY])
      map.getView().setZoom(13)
    },
    // 定位
    location () {
      map.getView().setCenter([113.69374851887473, 25.569999999999999])
      // map.addLayer(road_layer)
      const lightPoint = new Point([0, 0])
      lightFeature = new Feature({
        geometry: lightPoint // geometry: new ol.geom.Point([0, 0]),
      })
      const vectorSource = new VectorSource({
        features: [lightFeature]
      })
      const vectorLayer = new VectorLayer({
        name: 'pointLight',
        zIndex: 99999,
        source: vectorSource,
        style: new Style({
          image: new Circle({
            radius: 6,
            fill: new Fill({
              color: '#00FFFF',
              opacity: 0.2
            })
          })
        })
      })
      map.addLayer(vectorLayer)
    },
    closeOverLay () {
      lightFeature.getGeometry().setCoordinates([0, 0])
      this.popupObject = []
      this.coordinates = []
      const closer = document.getElementById('popup-closer')
      if (this.popup) {
        this.popup.setPosition(undefined)
      }

      this.showOw = false
      closer.blur()
    },
    addOverLay (coordinates, id, object) {
      const element = document.getElementById('popup')
      element.style.transform = null
      this.popup = new Overlay({
        element: element,
        positioning: 'bottom-center',
        autoPan: true,
        autoPanAnimation: {
          duration: 250
        }
      })
      // content.innerHTML = '<p>图层属性</p><code>' + object + '</code>' // 这个课扩展
      if (id == 'pipe_network') {
        const {
          feature_point,
          buried_depth,
          ground_elevation,
          geophysical_point_number,
          pipe_network_number,
          connection_point_number,
          pipeline_material,
          pipe_diameter_size,
          coordinate_point_x,
          coordinate_point_y,
          factory,
          well_lid_texture,
          well_depth,
          valve_type, // 阀门类型
          status, // 状态0 良好 ,1 密封性能差 ,2 损坏 ,3 联通阀门关闭。
          install_time, // 安装时间
          unit_num, // 机组数量
          unit_power, // 机组功率
          last_maintenance_time, // 上次保养时间
          subordinate_way, // 所属道路
          forcing_pump_status, // 加压泵类型
          zone_id
        } = object
        const statusName = status == 0 ? '良好' : status == 1 ? '密封性能差' : status == 2 ? '损坏' : '联通阀门关闭'
        const name = object.feature_point
        console.log(name)
        if (name == '水表') {
          const params = {
            geophysicalPointNumber: geophysical_point_number,
            zoneId: zone_id
          }
          this.$http
            .get('/pipe-network/user_water_meters/page', { params })
            .then((res) => {
              const total = res.data.total

              // 水表卡片属性
              this.popupObject = [
                ['特征点附属物名称', feature_point],
                ['物探点号', geophysical_point_number],
                // ['厂家', factory],
                // ['口径', pipe_diameter_size],
                // ['用户编号', ''],
                ['坐标X', coordinate_point_x],
                ['坐标Y', coordinate_point_y],
                ['地面高程m', ground_elevation],
                ['用户数量', total, params],
                ['安装时间', install_time]
              ]
            })
            .catch(() => { })
        } else if (name == '水表井' || name == '阀门井') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['井盖材质', well_lid_texture],
            ['井深', well_depth],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '排水阀' || name == '排气阀') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['阀门类型', valve_type],
            ['状态', statusName],
            ['口径', 'DN' + pipe_diameter_size],
            ['厂家', factory],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '加压泵站') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            // ['建设时间', install_time],
            ['机组数量', unit_num],
            ['机组功率', unit_power],
            ['加压泵类型', forcing_pump_status],
            ['厂家', factory],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '预留口') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['口径', 'DN' + pipe_diameter_size],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '阀门') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['阀门类型', valve_type],
            ['口径', 'DN' + pipe_diameter_size],
            ['厂家', factory],
            ['状态', statusName],
            ['上次保养时间', last_maintenance_time],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '水池') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else if (name == '消防栓') {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            ['编号', pipe_network_number],
            ['口径', 'DN' + pipe_diameter_size],
            ['状态', statusName],
            ['所属道路', subordinate_way],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['地面高程m', ground_elevation],
            ['安装时间', install_time]
          ]
        } else {
          this.popupObject = [
            ['特征点附属物名称', feature_point],
            ['物探点号', geophysical_point_number],
            // ['连接点号', connection_point_number],
            ['管材', pipeline_material],
            ['管径', 'DN' + pipe_diameter_size],
            ['地下埋深', buried_depth + 'm'],
            ['地面高程m', ground_elevation],
            ['坐标X', coordinate_point_x],
            ['坐标Y', coordinate_point_y],
            ['安装时间', install_time]
          ]
        }
      } else if (id == 'gis_pipe_line') {
        const {
          start_class_no,
          end_class_no,
          start_geophysical_point_number,
          end_geophysical_point_number,
          pipe_material,
          pipe_diameter,
          buried_depth
        } = object
        // object.geo_json  coordinates
        var distance = 0
        if (JSON.parse(object.geo_json).type === 'LineString') {
          var points = JSON.parse(object.geo_json).coordinates
          var from = turf.point(points[0])
          var to = turf.point(points[1])
          var options = { units: 'kilometers' }
          distance = turf.distance(from, to, options) * 1000
          distance = distance.toFixed(4)
        }
        // alert(points)
        this.popupObject = [
          ['起点分类编码', start_class_no],
          ['终点分类编码', end_class_no],
          ['起点物探点', start_geophysical_point_number],
          ['终点物探点', end_geophysical_point_number],
          ['管材', pipe_material],
          ['管径', pipe_diameter],
          ['长度', distance],
          ['埋深', buried_depth]
        ]
      } else if (id === 'remote_water_meter') {
        const { appearance_no, address, diameter, longitude, latitude } = object
        this.popupObject = [
          ['名称', '分区流量计'],
          ['流量计编号', appearance_no],
          ['地址', address],
          ['口径', diameter],
          ['X坐标', longitude],
          ['Y坐标', latitude]
        ]
      } else if (id === 'yc_user_remote_water_meter') {
        console.log(object)
        const { class_no, address, meter_num, coordinate_point_x, coordinate_point_y } = object
        this.popupObject = [
          ['名称', '贸易结算表'],
          ['分类编码', class_no],
          ['地址', address],
          ['表数量', meter_num],
          ['X坐标', coordinate_point_x],
          ['Y坐标', coordinate_point_y]
        ]
      } else {
        const { geophysical_point_number, connection, pipeline_material, pipe_diameter_size, buried_depth } = object
        // object.geo_json  coordinates
        var distance = 0
        if (JSON.parse(object.geo_json).type === 'LineString') {
          var points = JSON.parse(object.geo_json).coordinates
          var from = turf.point(points[0])
          var to = turf.point(points[1])
          var options = { units: 'kilometers' }
          distance = turf.distance(from, to, options) * 1000
          distance = distance.toFixed(4)
        }
        // alert(points)
        this.popupObject = [
          ['物探起点点号', geophysical_point_number],
          ['物探终点点号', connection],
          ['管材', pipeline_material],
          ['管径', pipe_diameter_size],
          ['长度', distance],
          ['埋深', buried_depth]
        ]
      }
      this.showOw = true
      map.addOverlay(this.popup)
      this.popup.setPosition(coordinates)
    }
  }
}
</script>
<style lang="less" scoped>
.changeBtn {
  position: absolute;
  z-index: 9999999;
  bottom: 8px;
  right: 8px;
}

/deep/ .ol-scale-line.ol-unselectable {
  z-index: 9999;
}

.map_container {
  width: 100%;
  height: 100%;
  position: relative;

  .right-btn {
    background: rgba(0, 32, 54, 0.75);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    width: 354px;
    height: 36px;
    position: absolute;
    right: 40%;
    bottom: 4%;
    z-index: 5;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    .right-item {
      text-align: center;
      height: 36px;
      width: 44px;

      img {
        margin-top: 6px;
        height: 24px;
        width: 24px;
      }
    }

    .right-item:hover {
      background: rgba(0, 32, 54, 1);
      cursor: pointer;
    }
  }

  .map {
    width: 100%;
    height: 100%;
    position: relative;

    .radius {
      float: left;
      width: 4px;
      height: 21px;
      background: #0265ff;
      border-radius: 3px;
    }

    .radiusTitle {
      margin-left: 10px;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 16px;
      color: #404549;
      font-weight: 600;
    }

    .search-btn {
      height: 40px;
      width: 40px;
      position: absolute;
      z-index: 900;
      top: calc(16rem - 75px);
      background-image: linear-gradient(270deg, #e2e2e2 0%, #ffffff 100%);
      background: #f0f2f5 url(~@/assets/myImg/1/ns-icon-querynull.png) no-repeat center;
      // background-position: 40% 10%;
      background-size: 16px 16px;
      border: 1px solid #ffffff;
      box-shadow: 6px 0 6px 0 rgba(0, 0, 0, 0.15);
      border-radius: 0 6px 6px 0;
      line-height: 65px;
      padding-left: 4px;
      color: black;
    }

    .search-btn:hover {
      background: #f0f2f5 url(~@/assets/myImg/1/ns-icon-query-lightnull.png) no-repeat center;
      background-size: 16px 16px;
      cursor: pointer;
      color: rgb(11, 145, 242);
    }

    .tube-btn {
      height: 40px;
      width: 40px;

      background-image: linear-gradient(270deg, #e2e2e2 0%, #ffffff 100%);
      background: #f0f2f5 url(~@/assets/myImg/1/ns-icon-burst.png) no-repeat center;
      // background-position: 40% 10%;
      background-size: 18px 18px;
    }

    //   .active-class {
    //     height: 36px;
    //     width: 36px;
    //     position: absolute;
    //       left:16rem;
    //     z-index: 5;
    //     top: calc(20rem - 75px);
    //     background-image: linear-gradient(270deg, #E2E2E2 0%, #FFFFFF 100%);
    // border: 1px solid #FFFFFF;
    // box-shadow: 6px 0 6px 0 rgba(0,0,0,0.15);
    //   }
  }

  .lengend {
    position: absolute;
    background: rgba(0, 32, 54, 0.75);
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    bottom: 24px;
    right: 24px;
    z-index: 5;
    width: 140px;

    .layers {
      width: 100%;
      max-height: 380px;
      overflow-y: scroll;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 3px;
        height: 1px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: rgba(0, 32, 54, 0.75);
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
        border-radius: 3px;
        background: rgba(0, 32, 54, 0.75);
      }

      .layer {
        color: #ffffff;
        width: 140px;
        height: 26px;
        background: rgba(255, 255, 255, 0.11);
        border-radius: 3px;
        margin: 0 auto 5px;
        display: flex;
        align-items: center;

        .layer-prefix {
          height: 22px;

          .prefix_icon {
            height: 100%;
            width: 20px;
            margin-left: 12px;
            margin-right: 12px;
          }
        }

        .layer-content {
          width: 100%;
          flex: 1;
          font-size: 10px；;
        }

        .layer-sufix {
          margin-left: 12px;
          margin-right: 12px;
          height: 12px;
          width: 12px;
        }
      }
    }

    .lengend_title {
      background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
      border-radius: 6px 6px 0 0;
      display: flex;
      height: 26px;
      align-items: center;
      color: #ffffff;
      margin-bottom: 9px;

      .legend_title--prefix {
        width: 4px;
        height: 12px;
        background-color: #0890f2;
        margin-right: 5px;
        margin-left: 12px;
      }

      .legend_title--content {
        width: 100%;
        flex: 1;
        font-family: MicrosoftYaHeiSemibold;
        font-size: 12px;
        color: #ffffff;
        font-weight: 600;
        line-height: 12px;
        height: 12px;
      }

      .legend_title--sufix {
        width: 12px;
        height: 12px;
        margin-right: 12px;
      }
    }
  }
}

.ol-popup {
  position: absolute;
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  width: 160px;

  .popup_title {
    display: flex;
    height: 24px;
    align-items: center;
    background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
    border-radius: 6px 6px 0 0;
    margin-bottom: 9px;

    .popup_title--prefix {
      width: 4px;
      height: 12px;
      background-color: #0890f2;
      margin-right: 5px;
      margin-left: 12px;
    }

    .popup_title--content {
      font-family: MicrosoftYaHei;
      font-size: 13px;
      color: #ffffff;
      font-weight: 400;
      width: 100%;
      flex: 1;
      line-height: 12px;
      height: 12px;
    }

    .popup_title--sufix {
      width: 12px;
      height: 12px;
      margin-right: 12px;
    }
  }
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: '✖';
}

// .ul li{
//  font-family: MicrosoftYaHei;
//  font-size: 13px;
//  color: #25c04c;
//  font-weight: 400;
//  padding-bottom: 10px;
// }</style>
